var Acr = Acr || {};

Acr.MultiTabNavigation = function () {
  var DeepLink;
  var $element;
  var $slideElement;
  var $tabbedMenu;
  var $tabList;
  var $button;
  var $leftArrowSvg;
  var $rightArrowSvg;
  var $swiperPagination;
  var debounce;
  var maxTabs;
  var defaultTab;
  var $multiTabNavigationSwiper;

  const slideElement = '[data-navigation-label]';
  const tabbedMenu = '.tabbed-menu';
  const tabList = '.acr-multi-tab-list';
  const leftArrowSvgClass = '.js-arrow-left';
  const rightArrowSvgClass = '.js-arrow-right';
  const swiperPaginationClass = '.js-swiper-pagination';
  const singleSlideClass = 'acr-multi-tab-single-slide';

  function getComponentData() {
    maxTabs = parseInt($element.data('maxTabs'), 10) - 1;
    defaultTab = parseInt($element.data('defaultTab'), 10) - 1;

    if (!defaultTab || !$slideElement.length || defaultTab >= $slideElement.length || defaultTab >= maxTabs) {
      defaultTab = 0;
    }
  }

  function initSwiper() {
    let $firstMultiTab;
    let $cta;
    let $theme;
    const numbOfSlides = $element.find('.swiper-slide').length;

    if (numbOfSlides < 2) {
      $element.addClass(singleSlideClass);
      $firstMultiTab = $('.swiper-slide').find('.acr-multi-tab-content');
      $cta = $('.acr-cta-text', $firstMultiTab);
      if ($firstMultiTab.length > 0) {
        $theme = $firstMultiTab.data('theme');
        changeTheme($theme, $cta, $element);
      }
    } else {
      $multiTabNavigationSwiper = new Swiper($element.find('.swiper-container'), {
        speed: 400,
        slidesPerView: 1,
        loop: true,
        initialSlide: defaultTab,
        pagination: {
          el: $swiperPagination,
          clickable: true,
          bulletClass: 'acr-multi-tab-pagination-bullet',
          bulletActiveClass: 'acr-multi-tab-pagination-bullet-active',
        },
        navigation: {
          nextEl: $rightArrowSvg,
          prevEl: $leftArrowSvg,
        },
      });
      $multiTabNavigationSwiper.on('slideChange', function () {
        if (Acr.TrackingManager) {
          Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
        }
        afterChange($multiTabNavigationSwiper);
      });
      $firstMultiTab = $($multiTabNavigationSwiper.slides[$multiTabNavigationSwiper.activeIndex]).find('.acr-multi-tab-content');
      $cta = $('.acr-cta-text', $firstMultiTab);
      if ($firstMultiTab.length > 0) {
        $theme = $firstMultiTab.data('theme');
        changeTheme($theme, $cta, $element);
      }
      executeLazyLoading();
    }
  }

  function afterChange($swiper) {
    var $currentSlide = $($swiper.slides[$swiper.activeIndex]);
    var $cta = $currentSlide.find('.acr-cta-text');
    var theme = $currentSlide.find('.acr-multi-tab-content').data('theme');

    changeTheme(theme, $cta);
    evaluateSelectedTab($swiper.realIndex);
  }

  function changeTheme(theme, $cta) {
    $element.removeClass('dark-theme light-theme');

    $element.addClass(theme);

    $cta.removeClass('is-black is-white');

    if (theme === 'dark-theme') {
      $cta.addClass('is-white');
    } else {
      $cta.addClass('is-black');
    }
  }

  function createNavigation() {
    if ($slideElement.length > 1) {
      var $navList = $('<ul class="acr-multi-tab-list"></ul>');

      $slideElement.each(function (index, el) {
        if (index > maxTabs) {
          return false;
        }
        const activeClass = index === defaultTab ? 'active' : '';
        const buttonLabel = el.dataset.navigationLabel;
        const buttonId = el.id;
        var $listItem = $('<li class="' + activeClass + '"></li>');
        $button = $('<button class="acr-multi-tab-button acr-label-2 js-tab-link" data-toggle="tab" tab-id="' + stripHtmlTags(buttonId) + '">' + buttonLabel + '</button>');
        var trackingData = $(el).data('trackingNoClick');

        if (trackingData) {
          $button.attr('data-tracking', trackingData);
        }

        $listItem.append($button);
        $navList.append($listItem);
      });

      if ($navList) {
        $tabbedMenu.append($navList);
        $tabbedMenu.css({ display: 'block' });
        $tabList = $tabbedMenu.find(tabList);
      }
    }
  }

  function stripHtmlTags(str) {
    if (!str) {
      return false;
    }
    str = $('<p>' + str + '</p>').text();
    str = str.replace(/(™|®|©|&trade;|&reg;|&copy;|&#8482;|&#174;|&#169;)/g, '');
    return str.replace(/ /g, '-');
  }

  function changeSlide(e) {
    var position = $tabbedMenu.find('button').index(e.target);
    $multiTabNavigationSwiper.slideToLoop(position);
  }

  function selectTab(selectedTab) {
    var position = $tabbedMenu.find('button').index(selectedTab);
    $multiTabNavigationSwiper.slideToLoop(position);
  }

  function deepLinking() {
    if ($element.length) {
      var hashTab = DeepLink.getTabIdHashElement($element[0]);
      if (hashTab) {
        selectTab($(hashTab));
      }
    }
  }

  function evaluateSelectedTab(index) {
    $tabList.find('li').removeClass('active');
    $tabList.find('li').eq(index).addClass('active');
  }

  function onResize(event) {
    clearTimeout(debounce);
    debounce = setTimeout(resize, 250);
  }

  function resize() {
    var $header = $element.find('.acr-multi-tab-header');
    var height = $header.outerHeight(true);
    height -= 20;

    $('.acr-multi-tab-arrows, .acr-multi-tab-xs-header', $element).css({
      top: height + 'px',
    });
  }

  function executeLazyLoading() {
    var imagesToLoad = [].slice.call(document.querySelectorAll('.swiper-slide img[loading="lazy"]'));
    Utility.initLazyLoadingIO(imagesToLoad, Acr.LazyLoadingHelper.loadImage);
  }

  function initSelectors(element) {
    $element = $(element);
    $slideElement = $element.find(slideElement);
    $tabbedMenu = $element.find(tabbedMenu);
    $leftArrowSvg = $element.find(leftArrowSvgClass);
    $rightArrowSvg = $element.find(rightArrowSvgClass);
    $swiperPagination = $element.find(swiperPaginationClass);
  }

  function bindEvents() {
    $(window).on('resize', onResize);
    $(window).on('load', deepLinking);
    $(window).on('hashchange', deepLinking);
    $element.find('.acr-multi-tab-button').on('click', changeSlide);
  }

  function init(element) {
    DeepLink = window.Acr ? window.Acr.DeepLinking || {} : {};
    initSelectors(element);
    getComponentData();
    createNavigation();
    bindEvents();
    initSwiper();
    resize();
  }

  return {
    init: init,
  };
};
